var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "appeal-points",
      class: [_vm.isSearchResult ? "fll" : "mt20"],
      attrs: { "data-test": "appeal-point-div" },
    },
    [
      _c("p", { staticClass: "fll h-style-02" }, [
        _vm._v("\n    アピールポイント\n  "),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "flr link-type-01" }, [
        _c(
          "a",
          {
            style:
              "cursor: pointer; background: url(" +
              _vm.userCommonImageUrlForPc +
              "/icn_arrow_01.png) no-repeat left;",
            attrs: { target: "_blank", "data-test": "help" },
            on: {
              click: function ($event) {
                return _vm.openHelpPopUp("icon.html")
              },
            },
          },
          [_vm._v("\n      アイコンの説明\n    ")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "clearfix" }),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "appeal-point" },
        _vm._l(_vm.prIconsMaster, function (prIcon) {
          return _c("li", {
            key: prIcon.id,
            class: { on: _vm.isSetPr(prIcon.id) },
            attrs: {
              id: _vm.targetIdMap.mainArticle.pr[prIcon.id],
              "data-test": "pr-" + prIcon.id,
            },
            domProps: { textContent: _vm._s(prIcon.name) },
          })
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }